import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import Image from "components/landing/image"
import StyledLink from "components/landing/link"
import Textarea from "components/landing/textarea"

const StyledSplitBlock = styled(Flex).attrs((props) => ({
  flexDirection: { _: "column", desktop: "row" },
  justifyContent: "center",
  ...props,
}))`
  gap: 16px;
  ${(props) => props.theme.mediaQueries.desktop`
    gap: 42px;
  `}
`

const TextBlock = styled(Box)`
  flex: 1;
`

const SplitBlock = ({ section }) => {
  const { img_block, text_block, style } = section

  return (
    <StyledSplitBlock {...style}>
      <StyledLink target="_blank" url={img_block.url}>
        <Image alt={img_block.alt} image={img_block} lazyload />
      </StyledLink>

      <TextBlock {...text_block.style}>
        <Textarea element={text_block} lazyload />
      </TextBlock>
    </StyledSplitBlock>
  )
}

SplitBlock.propTypes = {
  section: PropTypes.object,
}

export default SplitBlock
